<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Important notice!') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <p>{{ _('On %1$s the system has sent a commission invoice to your billing address as specified in Johku Settings. The due date for this invoice was %2$s.').replace('%1$s', DateTime.fromSeconds(Number(invoiceTs), { zone: this.timezone }).toFormat(this.dateFormat)).replace('%2$s', DateTime.fromSeconds(Number(dueTs), { zone: this.timezone }).toFormat(this.dateFormat)) }}
               {{ _('For one reason or another, payment for this invoice has not been registered in our financial management system.') }}
               {{ !Number(deactivateTs) ? '' : _('This has caused an automation to flag your Johku shop for deactivation on %s.').replace('%s', DateTime.fromSeconds(Number(deactivateTs), { zone: this.timezone }).toFormat(this.dateFormat)) }}
               {{ _('Please note that it may take a few business days for the payment to be registered in our system.') }}</p>
            <p>{{ _('There is a fee for this due date notice. A reminder fee of %s EUR (VAT 0%) will be automatically added to your next commission invoice.').replace('%s', 7) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="downloadInvoice"><i class="fa fa-fw fa-download"></i> {{ _('Download outstanding invoice') }}</button>
      <button class="btn btn-info" v-on:click="help"><i class="fa fa-fw fa-info"></i> {{ _('Instructions') }}</button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      DateTime: DateTime,
    }
  },
  props: ['deactivateTs', 'notifyTs', 'baseDomain', 'shopId', 'apiKey'],
  computed: {
    ...mapGetters(['dateFormat', 'timezone']),
    invoiceTs () {
      return DateTime.fromSeconds(Number(this.notifyTs), { zone: this.timezone }).minus({ days: 18 }).toUnixInteger()
    },
    dueTs () {
      return DateTime.fromSeconds(Number(this.notifyTs), { zone: this.timezone }).minus({ days: 4 }).toUnixInteger()
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    downloadInvoice () {
      window.open(this.baseDomain + '/' + this.shopId + '/license?outstanding=true&apikey=' + this.apiKey)
    },
    help () {
      window.open('https://support.johku.com/Johku-Kauppiaalle/Johkun-palvelulaskutus/')
    }
  }
}
</script>